module.exports = __webpack_public_path__ + "static/media/third_party_poker.479dc0d3.svg";